import { FC } from 'react'
import styled from 'styled-components'
import { CustomChip } from './Chip'

export type RecommendTag = {
  name: string
  isActive?: boolean
}

interface RecommendTagsProps {
  tags: RecommendTag[]
  onClickTag: (tag: RecommendTag) => void
}

const RecommendTags: FC<RecommendTagsProps> = ({ tags, onClickTag }) => {
  const handleChipClick = (tag: RecommendTag) => {
    onClickTag(tag)
  }

  return (
    <StyledWrapper>
      {tags.map((tag) => {
        return (
          <CustomChip
            key={`recommend-tag-${tag.name}`}
            color={tag.isActive ? 'primary' : 'default'}
            label={`#${tag.name}`}
            className="chip"
            onClick={() => {
              handleChipClick(tag)
            }}
          />
        )
      })}
    </StyledWrapper>
  )
}

export default RecommendTags

const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;

  & .chip {
    transition-property: all;
    &:hover {
      background-color: #f0fcff;
      color: #01a0ff;
    }
  }
`
